import { useTranslation } from "react-i18next";

import LandingContactSection from "../Home/LandingSections/LandingContactSection";

export default function Contact() {
	const { t } = useTranslation();
	const ts = (key: string) => t(`marketing.contact.${key}`);

	return (
		<div className="w-full flex flex-col items-center font-urbanist">
			<section className="w-full px-4 md:px-16 bg-[#F7F8FB]">
				<div className="max-w-[1420px] mx-auto py-14 sm:py-20 flex flex-col items-center text-center gap-6">
					<h1 className="text-[36px] md:text-[48px] font-bold leading-[120%] text-[#1D243C]">
						{ts("title")}
					</h1>
					<p className="text-[18px] leading-[150%] text-[#626373] max-w-[760px]">
						{ts("subtitle")}
					</p>
				</div>
			</section>
			<LandingContactSection />
		</div>
	);
}
